var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCar = function SvgCar(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 12.71,
    y2: 487.564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00efd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00acea"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 116.5,
    x2: 116.5,
    xlinkHref: "#a",
    y1: 12.71,
    y2: 487.564
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 395.5,
    x2: 395.5,
    xlinkHref: "#a",
    y1: 12.71,
    y2: 487.564
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m461.919 198.719-35.784-96.548a41.821 41.821 0 0 0 -39.079-27.171h-255.777a41.822 41.822 0 0 0 -39.079 27.171l-35.333 95.345-14.667 13.559a57.478 57.478 0 0 0 -20.2 43.694v140.6a41.817 41.817 0 0 0 41.834 41.631h26.4a41.762 41.762 0 0 0 41.766-41.627v-20.373h248v20.373a41.762 41.762 0 0 0 41.77 41.627h26.4a41.817 41.817 0 0 0 41.83-41.627v-144.233a57.825 57.825 0 0 0 -17.868-41.591zm-350.965-89.7a21.646 21.646 0 0 1 20.325-14.019h255.777a21.646 21.646 0 0 1 20.325 14.017l31.166 83.983h-23.347a68.6 68.6 0 0 0 -135.727 0h-199.685zm283.938 83.981h-95.121a48.6 48.6 0 0 1 95.121 0zm-282.892 202.373a21.739 21.739 0 0 1 -21.769 21.627h-26.4a21.8 21.8 0 0 1 -21.831-21.627v-26.186c6 3.864 13.9 5.813 21.834 5.813h48.166zm336.166 21.627h-26.4a21.739 21.739 0 0 1 -21.766-21.627v-20.373h48.166c7.934 0 15.834-1.949 21.834-5.813v26.186a21.8 21.8 0 0 1 -21.834 21.627zm21.834-83.395a21.6 21.6 0 0 1 -21.834 21.395h-384.332a21.6 21.6 0 0 1 -21.834-21.395v-78.836a37.524 37.524 0 0 1 13.323-28.605c.115-.1.268-.3.379-.406l13.647-12.758h378.736l9.565 10.326c.141.151.365.348.515.489a37.857 37.857 0 0 1 11.835 27.325z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m164 263a10 10 0 0 0 -10-10h-75a10 10 0 0 0 -10 10v52a10 10 0 0 0 10 10h75a10 10 0 0 0 10-10zm-20 42h-55v-32h55z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m443 263a10 10 0 0 0 -10-10h-75a10 10 0 0 0 -10 10v52a10 10 0 0 0 10 10h75a10 10 0 0 0 10-10zm-20 42h-55v-32h55z",
    fill: "url(#c)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m304.305 295h-96.605a10 10 0 1 0 0 20h96.61a10 10 0 1 0 0-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.305 264h-96.605a10 10 0 0 0 0 20h96.61a10 10 0 1 0 0-20z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car.6e8ab8ab.svg";
export { ForwardRef as ReactComponent };